import styled from '@emotion/styled'

export const SubscriptionPlansWrapper = styled.div`
  max-width: 1130px;
`
